import React from "react";
import { Grid, Typography } from "@material-ui/core";
import BeatLoader from "react-spinners/BeatLoader";

export default ({ auth }) => {
    const [user, initializing] = auth;
    return (
        <Grid
            container
            alignContent="center"
            alignItems="center"
            style={{
                justifyItems: "start",
                justifyContent: "space-between"
            }}
        >
                <Typography variant="h4" gutterBottom>
                    Logs
                </Typography>
    {initializing ? <BeatLoader /> : <Typography variant="h4" gutterBottom>{user.profile.name}</Typography>}
        </Grid>
    );
};
